import { Add } from '@mui/icons-material';
import { Button } from '@mui/material';
import { useAppDispatch } from '../../store/store';
import { openAddCareTeamModal } from '../../store/careTeams.slice';
import AddCareTeamModal from './modals/AddCareTeamModal';

const AddCareTeamButton = () => {
    const dispatch = useAppDispatch();
    return (
        <>
            <Button startIcon={<Add />} variant="contained" color="primary" fullWidth onClick={() => dispatch(openAddCareTeamModal())}>
                Add Care Team
            </Button>
            <AddCareTeamModal />
        </>
    );
};

export default AddCareTeamButton;
